import { logger } from 'helpers'
import { Dashboard, About, Embed } from 'views/core'

var routes = []
try {
  // eslint-disable-next-line
  routes = require('../projects/' + process.env.REACT_APP_PROJECT + '/routes')
} catch (e) {
  logger.debug('No project-specific routes')
}

const CoreRoutes = [
  {
    path: '/flow/dashboard',
    component: Dashboard,
    exact: true
  },
  {
    path: '/flow/about',
    component: About,
    exact: true
  },
  {
    path: '/flow/embed/:link',
    component: Embed,
    exact: true
  }
]

module.exports = CoreRoutes.concat(routes)



// WEBPACK FOOTER //
// ./src/routes/index.js